<template>
  <div class="mobile-menu">
    <div class="mobile-header flex sm:flex md:flex lg:hidden">
      <router-link class="mobile-logo" :to="{ name: 'loanSummary'}">
      <img :src="'/img/car-brands/' + brandLogo" alt="" width="119px" height="20px"/>
      </router-link>
      <div class="mobile-user-infomation flex">
        <div class="user-notify">
          <i class="vlicon icon-bell-alt" @click="notificationShow = !notificationShow"></i
          ><i class="notify-number" v-if="!allRead"></i>
          <div class="usernotify-content shadow-md" v-if="notificationShow">
            <div class="usernotify-popup-header">
              <div>Thông báo</div>
              <div class="usernotify-popup-action">
                <span @click.stop="handleClickAllRead">Đánh dấu đã đọc tất cả</span>
                <span> • </span>
                <span @click.stop="handleClickDeleteAll">Xoá tất cả</span>
              </div>
            </div>
            <perfect-scrollbar>
            <ul class="usernotify-popup">
              <li v-for="(item, index) in notifications" :key="index">
                <div
                  @click.stop="showDetailNotification(item.NotificationId, item.Title, item.Content)"
                  :class="{ 'active': item.IsRead != 1  && allRead === false}"
                  class="notification-item"
                >
                  <img
                    height="33px"
                    class="notification-icon"
                    src="@/assets/img/noti-icon.svg"
                    alt="Icon"
                  />
                  <p class="notification-title">
                    {{item.Title}}
                  </p>
                  <p
                    class="notification-des truncate text-left"
                  >
                    {{item.Content}}
                  </p>
                  <p class="notification-time">
                    {{ item.Time | moment("from", "now") }}
                  </p>
                  <div
                    class="notification-dismiss"
                    @click.stop="handleDeleteOne(item.NotificationId)"
                  >
                    <img
                      src="@/assets/img/icon-close.svg"
                      alt="Close"
                    />
                  </div>
                </div>
              </li>
            </ul>
            <infinite-loading spinner="bubbles" @infinite="fetchData">
              <div class="text-red" slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
            </perfect-scrollbar>
          </div>
        </div>
        <a id="mobileMenuToggleButton" href="#" @click="toggleMenu"
        ><i class="vlicon icon-menu"></i
        ></a>
      </div>
    </div>
    <transition name="slide">
    <div class="mobile-navdropdown sidenav" v-if="menuShow" style="display: block">
      <ul class="sidenav-nav" style="display: block!important" v-if="menuShow">
        <li>
          <router-link class="truncate" :to="{ name: 'loanSummary'}" active-class="active" @click.native="toggleMenu">
            <i class="vlicon icon-home"></i>Thông tin khoản vay
          </router-link>
        </li>
        <li>
          <router-link class="truncate" :to="{ name: 'profile'}" active-class="active" @click.native="toggleMenu">
            <i class="vlicon icon-user-o"></i>Thông tin khách hàng
          </router-link>
        </li>
        <li>
          <router-link class="truncate" :to="{ name: 'paymentIntroduction'}" active-class="active" @click.native="toggleMenu">
            <i class="vlicon icon-credit-card"></i>Thanh toán trực tuyến
          </router-link>
        </li>
        <li>
          <router-link class="truncate" :to="{ name: 'earlyPaymentList'}" active-class="active" @click.native="toggleMenu">
            <i class="vlicon icon-calculator"></i>Tính toán trả nợ sớm
          </router-link>
        </li>
        <li>
          <router-link class="truncate" :to="{ name: 'support'}" active-class="active" @click.native="toggleMenu">
            <i class="vlicon icon-user-o"></i>Yêu cầu hỗ trợ
          </router-link>
        </li>
        <li>
          <a class="truncate" href="#" @click="logout">
            <i class="vlicon icon-logout"></i>Đăng xuất</a>
        </li>
      </ul>
    </div>
    </transition>
  </div>
</template>

<script>
import { AuthService } from '../services/auth.service'
import { mapState, mapGetters } from 'vuex'
import { NotificationsService } from '../services/notifications.service'
import infiniteHandler from '@/mixins/infiniteScroll'
import InfiniteLoading from 'vue-infinite-loading'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  name: 'MobileHeader',
  mixins: [infiniteHandler],
  components: {
    InfiniteLoading,
    PerfectScrollbar
  },
  data () {
    return {
      notificationShow: false,
      titleDetail: '',
      contentDetail: '',
      menuShow: false,
      brandLogo: 'toyota.png'
    }
  },
  computed: {
    ...mapState('notifications', {
      notifications: 'items'
    }),
    ...mapGetters('notifications', [
      'allRead'
    ])
  },
  methods: {
    toggleBodyClass (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'addClass') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    toggleMenu () {
      if (this.menuShow) {
        this.toggleBodyClass('removeClass', 'overflow-hidden')
      } else {
        this.toggleBodyClass('addClass', 'overflow-hidden')
      }
      this.menuShow = !this.menuShow
    },
    logout () {
      AuthService.makeLogout()
    },
    fetchData: function ($state) {
      this.infiniteHandler($state, 'notifications', 'Notification/GetNotification', { pageSize: 5 })
    },
    handleClickAllRead () {
      NotificationsService.setAllRead()
    },
    handleClickDeleteAll () {
      NotificationsService.deleteAll()
    },
    handleDeleteOne (notificationId) {
      NotificationsService.deleteOne(notificationId)
    },
    showDetailNotification (notificationId, title, content) {
      NotificationsService.setRead(notificationId)
      this.$bus.$emit('openModal', {
        title: title,
        content: content
      })
    }
  },
  created () {
    const self = this
    this.$bus.$on('changeBrandLogo', function (b) {
      self.brandLogo = b
    })
  },
  destroyed () {
    this.toggleBodyClass('removeClass', 'overflow-hidden')
  }
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
